// Case-insensitive "does any of these fields contain the query" — the one matcher
// behind every in-page client search, so the Activity stream, Work items and
// Requests can never disagree about what a query matches.

/**
 * Normalise a query for matching: trimmed and lowercased.
 * @param {*} query
 * @returns {string}
 */
export const normalizeQuery = (query) => String(query ?? '').trim().toLowerCase();

/**
 * Whether any field contains the query. An empty (or whitespace-only) query matches
 * everything, so "no search" and "empty search" are the same state.
 * @param {*} query
 * @param {...*} fields  Values to look in; null/undefined are skipped.
 * @returns {boolean}
 */
export const matchesQuery = (query, ...fields) => {
  const q = normalizeQuery(query);
  if (!q) return true;
  return fields.some((f) => f != null && String(f).toLowerCase().includes(q));
};
